module.exports = __webpack_public_path__ + "static/media/italy.604345b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/flag/italy.svg
// module id = 1207
// module chunks = 39